import { render, staticRenderFns } from "./ModuleClientAccount.vue?vue&type=template&id=5bd5dffe&scoped=true&lang=pug&"
import script from "./ModuleClientAccount.vue?vue&type=script&lang=js&"
export * from "./ModuleClientAccount.vue?vue&type=script&lang=js&"
import style0 from "./ModuleClientAccount.vue?vue&type=style&index=0&id=5bd5dffe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd5dffe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
installComponents(component, {VAvatar})
